import { MessageBarType } from "@fluentui/react";
import { BwjPalette } from "../../../app/app-theme";

export const getBwjAnnouncementBannerColorScheme = (type: MessageBarType) => {
  switch(type) {
    case MessageBarType.error:
    case MessageBarType.blocked:
      return { main: BwjPalette.themeError, background: BwjPalette.themeErrorBackground };
    case MessageBarType.warning:
    case MessageBarType.severeWarning:
      return { main: BwjPalette.themeWarning, background: BwjPalette.themeWarningBackground };
    case MessageBarType.success:
      return { main: BwjPalette.themeSuccess, background: BwjPalette.themeSuccessBackground };
    default: return { main: BwjPalette.themeInfo, background: BwjPalette.themeInfoBackground };
  }
};